import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { safelyRequestIdleCallback } from '@peloton/analytics/safelyRequestIdleCallback';
import { Endpoint, report } from '@engage/analytics';
import { getDevice } from '@webtv/devices';
import { ENVIRONMENT, isProdEnv } from '@webtv/env';
import { captureException } from '@webtv/error-reporting-v2';

var getEndpoint = function getEndpoint() {
  var environment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ENVIRONMENT;
  return isProdEnv(environment) ? Endpoint.Production : Endpoint.Test;
};

export var trackWebVital = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var device, endpoint, metric;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            try {
              device = getDevice();
              endpoint = getEndpoint(ENVIRONMENT);
              metric = {
                type: 'web-vital',
                device: device.friendlyName,
                platform: device.platform,
                osVersion: device === null || device === void 0 ? void 0 : device.osVersion,
                payload: payload
              };
              safelyRequestIdleCallback(function () {
                return report(JSON.stringify(metric), endpoint);
              });
            } catch (err) {
              // report errors, but no not escalate outside of this catch block (users don't care)
              captureException(err);
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function trackWebVital(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var trackWebTVCustomMetric = function trackWebTVCustomMetric(environment) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
      var prefix,
          device,
          endpoint,
          metric,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              prefix = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'jupiter.webtv.site-performance.';

              try {
                device = getDevice();
                endpoint = getEndpoint(environment);
                metric = {
                  type: 'custom',
                  device: device.friendlyName,
                  platform: device.platform,
                  osVersion: device.osVersion,
                  prefix: prefix,
                  payload: payload
                };
                safelyRequestIdleCallback(function () {
                  return report(JSON.stringify(metric), endpoint);
                });
              } catch (err) {
                // report errors, but no not escalate outside of this catch block (users don't care)
                captureException(err);
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var trackCustomMetric = trackWebTVCustomMetric(ENVIRONMENT);